import React from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import { Brain, TrendingUp, LineChart, Zap, Database, BarChart } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Link } from 'react-router-dom';

const DataAIPage = () => {
  const services = [
    {
      icon: Brain,
      title: 'Machine Learning',
      description: 'Build, train, and deploy ML models using AWS SageMaker and cutting-edge AI tools',
    },
    {
      icon: TrendingUp,
      title: 'Predictive Analytics',
      description: 'Leverage data to predict trends and make informed business decisions',
    },
    {
      icon: LineChart,
      title: 'Business Intelligence',
      description: 'Transform raw data into actionable insights with real-time dashboards',
    },
    {
      icon: Database,
      title: 'Data Lake Architecture',
      description: 'Scalable data lakes for storing and analyzing massive datasets',
    },
    {
      icon: Zap,
      title: 'Real-time Processing',
      description: 'Process streaming data in real-time with AWS Kinesis and Lambda',
    },
    {
      icon: BarChart,
      title: 'Data Visualization',
      description: 'Interactive dashboards and reports using QuickSight and custom solutions',
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#020B1A] to-[#061426]">
      <Navbar />
      
      <section className="relative bg-gradient-to-br from-[#020B1A] via-[#061426] to-[#0A1E3F] overflow-hidden text-white pt-32 pb-24 mt-16">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-20 w-96 h-96 bg-cyan-500/30 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-blue-600/30 rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
              Data & AI/ML Solutions
            </h1>
            <p className="text-xl text-gray-300 mb-10 leading-relaxed">
              Transform your data into actionable insights with advanced AI/ML capabilities. Harness the power of artificial intelligence to drive innovation.
            </p>
            <Link to="/contact">
              <Button className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-medium px-8 py-6 text-lg transition-all duration-300" style={{ boxShadow: '0 0 30px rgba(0, 212, 255, 0.5)' }}>
                Explore AI Solutions
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-b from-[#061426] to-[#020B1A]">
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">AI/ML & Data Services</h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Comprehensive data and AI solutions for modern businesses
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const Icon = service.icon;
              return (
                <div key={index} className="bg-gradient-to-b from-[#061426] to-[#020B1A] border-2 border-cyan-500/30 rounded-xl p-8 transition-all duration-300 hover:border-cyan-400 hover:shadow-xl">
                  <div className="w-14 h-14 bg-gradient-to-br from-cyan-500/20 to-blue-600/20 border border-cyan-500/30 rounded-lg flex items-center justify-center mb-6">
                    <Icon className="w-7 h-7 text-cyan-400" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">{service.title}</h3>
                  <p className="text-gray-400 leading-relaxed">{service.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-[#020B1A] via-[#061426] to-[#0A1E3F] overflow-hidden text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Ready to Unlock Your Data's Potential?
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-3xl mx-auto">
            Let our AI experts help you build intelligent solutions
          </p>
          <Link to="/contact">
            <Button className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-medium px-10 py-6 text-lg transition-all duration-300" style={{ boxShadow: '0 0 30px rgba(0, 212, 255, 0.5)' }}>
              Schedule AI Consultation
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DataAIPage;